export default "__VITE_ASSET__7e600970__"